import { FIREBASE } from 'config';
function initFirebaseApp() {
    if (window.firebase.apps.length === 0) {
        window.firebase.initializeApp(FIREBASE);
    }
}
function wrapIdentity(raw) {
    if (!raw)
        return null;
    return {
        uid: raw.uid,
        email: raw.email ?? null,
        emailVerified: Boolean(raw.emailVerified),
        displayName: raw.displayName ?? null,
        photoURL: raw.photoURL ?? null,
        getIdToken: (forceRefresh) => raw.getIdToken(forceRefresh),
        reload: () => raw.reload(),
    };
}
export function createFirebaseBrowserAdapter() {
    initFirebaseApp();
    const auth = () => window.firebase.auth();
    return {
        onIdentityChanged(listener) {
            return auth().onAuthStateChanged((raw) => listener(wrapIdentity(raw)));
        },
        getCurrentIdentity() {
            return wrapIdentity(auth().currentUser);
        },
        signInWithPassword(email, password) {
            return auth().signInWithEmailAndPassword(email, password);
        },
        async createAccount(email, password, displayName) {
            const credential = await auth().createUserWithEmailAndPassword(email, password);
            const user = credential.user;
            if (!user) {
                throw new Error('Account creation did not return a user');
            }
            await user.updateProfile({ displayName });
            await user.sendEmailVerification();
        },
        fetchSignInMethods(email) {
            return auth().fetchSignInMethodsForEmail(email);
        },
        signOut() {
            return auth().signOut();
        },
        sendPasswordResetEmail(email) {
            return auth().sendPasswordResetEmail(email);
        },
        confirmPasswordReset(oobCode, newPassword) {
            return auth().confirmPasswordReset(oobCode, newPassword);
        },
        async applyEmailVerificationCode(oobCode) {
            const a = auth();
            await a.applyActionCode(oobCode);
            if (a.currentUser) {
                await a.currentUser.reload();
            }
        },
        async resendEmailVerification() {
            const currentUser = auth().currentUser;
            if (!currentUser) {
                throw new Error('No authenticated user to resend verification to.');
            }
            await currentUser.sendEmailVerification();
        },
        async changePassword(currentPassword, newPassword) {
            const a = auth();
            const currentUser = a.currentUser;
            if (!currentUser) {
                throw new Error('No authenticated user');
            }
            if (!currentUser.email) {
                throw new Error('Authenticated user has no email');
            }
            const credential = window.firebase.auth.EmailAuthProvider.credential(currentUser.email, currentPassword);
            await currentUser.reauthenticateWithCredential(credential);
            await currentUser.updatePassword(newPassword);
        },
    };
}
